export const oauthScopeOptions = [
	{ value: 'profile', label: 'Profile', description: 'Basic manager profile and safe profile preferences.' },
	{ value: 'game:read', label: 'View your game', description: 'Catalogued clubs, squad, tactics, training, fixtures, competitions, market, and union data.' },
	{ value: 'game:write', label: 'Manage your game', description: 'View and change catalogued permitted game-management data. Includes game read access.', risk: 'write' },
	{ value: 'social', label: 'Social connections and messages', description: 'Friends, chats, and notifications.', risk: 'high' },
	{ value: 'commerce', label: 'Store and purchase data', description: 'Inventories, club tokens, and subscriptions.', risk: 'high' },
	{ value: 'clubs:dangerous', label: 'Irreversible club actions', description: 'Only the specifically catalogued irreversible club actions.', risk: 'high' },
	{ value: 'offline_access', label: 'Stay connected', description: 'Allow rotating refresh tokens when the manager is away.' },
];

export const oauthScopes = oauthScopeOptions.map(scope => scope.value);

export function oauthScopeLabel(scope) {
	return oauthScopeOptions.find(option => option.value === scope)?.label || scope;
}
